import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_5 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_6 = {
  key: 2,
  class: "modal-footer"
}


import '@/styles/ms-button-styles.scss'
import { ModalSize } from '@/utilities/enums'


export default /*@__PURE__*/_defineComponent({
  __name: 'MsModal',
  props: {
  modalId: {
    type: String,
    required: true
  },
  modalWidth: {
    type: String,
    default: ModalSize.md
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "7ef2b383": (__props.modalWidth)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: __props.modalId,
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$slots.header)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "header")
            ]))
          : _createCommentVNode("", true),
        (_ctx.$slots.body)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "body")
            ]))
          : _createCommentVNode("", true),
        (_ctx.$slots.footer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})